module.exports = __webpack_public_path__ + "static/BE_coffeecup_cinemagraphstill-48046504b3985b9cd43e22d0aeb1ca4a.jpg";